import React, { useEffect, useState } from "react";

/**
 * B-55: one run of tiles in My Collection's grid that steps aside while it is
 * far from the visible area.
 *
 * Drawing in batches (CollectionPage) only delays the cost: a user who
 * scrolled a 2,003-card tab to the end used to end up with every tile on the
 * page again, the same DOM as before (745 MB renderer, 46% janky frames).
 * Each run now watches itself. Once it is more than 1,500 px above or below
 * the visible area, its tiles are unmounted and an empty box of the height it
 * just measured keeps its place, so nothing on screen moves. Back within
 * 1,500 px, the tiles are drawn again. A long scroll keeps a few runs of tiles
 * on the page, not every card drawn so far.
 *
 * `children` is a function, so a run that stands aside builds no tiles at all.
 * Without IntersectionObserver the tiles are always drawn.
 */
const CollectionTileChunk = ({ root, style, children }) => {
  const [el, setEl] = useState(null);
  // 0 = drawn. A box that measured 0 (not laid out) keeps its tiles.
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (!el || typeof IntersectionObserver === "undefined") return undefined;
    const observer = new IntersectionObserver((entries) => {
      // The newest report wins when several arrive together.
      const entry = entries.pop();
      setHeight(entry.isIntersecting ? 0 : entry.boundingClientRect.height);
    }, { root, rootMargin: "1500px 0px" });
    observer.observe(el);
    return () => observer.disconnect();
  }, [el, root]);
  return (
    <div ref={setEl} style={height ? { height } : style}>
      {!height && children()}
    </div>
  );
};

export default CollectionTileChunk;
